import logger from '@/utils/logger.js'
import store from '@/store/store.js';

export function sendMessageToDisc(Message, Username = 'Anonymous', csWebhook = '') {
    if (store.state.Einstellungen
        && store.state.Einstellungen.useDiscordWebhook
        && store.state.Einstellungen.discordWebhookURL) {
        let username = Username
        if (store.state.User && username == 'Anonymous') {
            username = store.state.User.displayName
            logger.log(store.state.User.displayName)
        }
        const data = {
            content: Message,
            username: username
        }
        const url = csWebhook === '' ? store.state.Einstellungen.discordWebhookURL : csWebhook
        // fetch ist asynchron; Netzwerkfehler werden hier im catch geloggt
        // (der frühere XHR-try/catch hätte sie ohnehin nicht erfasst).
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }).catch((err) => {
            logger.log(err.message)
        })
        return true
    }
}
